import type { HTMLAttributes, PropsWithChildren } from 'react';

import styles from './ArticleItemBody.module.scss';

type Props = PropsWithChildren<HTMLAttributes<HTMLElement>>;

export function ArticleItemBody({ children, className = '', ...rest }: Props) {
	return (
		<section className={`${styles.body} ${className}`} {...rest}>
			{children}
		</section>
	);
}
